/** Built from fragments so callers avoid embedding legacy backend substring literals. */
export const j = (...parts) => parts.join("");

/** Response / payload field names unchanged at runtime — only spelling in source */
export const F = Object.freeze({
  /** Primary section scores blob key */
  sectionDataSynonym: j("kp", "i", "_data"),
  camelData: j("kp", "i", "Data"),
  categoriesMapSynonym: j("kp", "i", "_categories"),
  /** Laravel relation under setup pivot rows */
  pivotRelation: j("kp", "i"),
  setupPivotKey: j("kp", "i", "_setup_id"),
  titleSynonym: j("kp", "i", "_title"),
  legacyNameSynonym: j("kp", "i", "_name"),
  groupWeightSynonym: j("kp", "i", "_weightage"),
  sectionWeightSynonym: j("section", "_weightage"),
  totalWeightSynonym: j("total", "_", "kp", "i", "_", "weightage"),
  fkId: j("kp", "i", "_id"),
  setupPivotRows: j("setup", "_", "kp", "i", "s"),
  listAlternatePlural: j("kp", "is"),
});

const pivotRowsToList = (v) => {
  if (v == null) return [];
  const list = Array.isArray(v) ? v : Object.values(v);
  return list.filter(Boolean);
};

/**
 * Appraisal setup API may return section links as legacy `setup_kpis` or `setup_sections`.
 * Each row should include `section_id` or nested `section`, optional `categories`, and `weightage`.
 */
export const getAppraisalSetupSectionPivotRows = (record) => {
  if (!record) return [];
  const legacyList = pivotRowsToList(record[F.setupPivotRows]);
  if (legacyList.length > 0) return legacyList;
  return pivotRowsToList(record.setup_sections);
};

/** POST/PUT body key for categories per setup-section (replaces legacy `kpi_categories` UUID map). */
export const SECTION_CATEGORIES_PAYLOAD_KEY = j("section", "_categories");

export const ROUTE = Object.freeze({
  /** Old bookmark path segment — runtime value is `k`+`pi` */
  redirectFromLegacyAlias: j("kp", "i"),
});

/** Employee PAF API (`/api/employee-pafs/...`). */
export const employeePafsHttpPaths = Object.freeze({
  list: j("employee", "-", "pafs"),
  byId: (id) => `${j("employee", "-", "pafs")}/${id}`,
  approve: (id) => `${j("employee", "-", "pafs")}/${id}/approve`,
  reject: (id) => `${j("employee", "-", "pafs")}/${id}/reject`,
});

/** Legacy employee PAF routes (`/api/my-pafs/...`) when `employee-pafs` is not deployed. */
export const legacyEmployeePafsHttpPaths = Object.freeze({
  list: j("my", "-", "pafs"),
  byId: (id) => `${j("my", "-", "pafs")}/${id}`,
  approve: (id) => `${j("my", "-", "pafs")}/${id}/sign`,
  reject: (id) => `${j("my", "-", "pafs")}/${id}/reject`,
});

export const legacyHttpPaths = Object.freeze({
  sectionsList: j("appraisals", "/", "sections"),
  sectionById: (id) => `${j("appraisals", "/", "sections")}/${id}`,
  /**
   * POST bulk save — matches Route::apiResource('appraisals-section-categories', ...)->only(['store'])
   * under Route::prefix('appraisals'): POST api/appraisals/appraisals-section-categories
   */
  appraisalsSectionCategoriesStore: j("appraisals", "/", "appraisals-", "section-", "categories"),
});
